import { BlueprintIcons_16Id } from "@blueprintjs/icons/src/generated/16px/blueprint-icons-16";
import SIcon from "../global/sicon";
import styles from "./sectionheading.module.css";

type Props = {
    count?: number;
    icon: BlueprintIcons_16Id;
    isLive?: boolean;
    title: string;
};

export default function HomeSectionHeading(
    {
        count,
        icon,
        isLive = false,
        title,
    }: Props,
): JSX.Element {
    return (
        <div className={`${styles.heading} ${isLive ? styles.live : ''}`}>
            <span className={styles.medallion} aria-hidden="true">
                <SIcon icon={icon} iconSize={16} />
            </span>
            <h2 className={styles.title}>{title}</h2>
            {
                count != null &&
                <span className={styles.count} aria-label={`${count} ${title.toLowerCase()}`}>
                    {count}
                </span>
            }
            <span className={styles.rule} aria-hidden="true" />
        </div>
    );
}
